import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";
import { PageHeader, Card, Button, Input, Textarea, Label, EmptyState } from "../components/ui-kit";
import { Plus, Users } from "lucide-react";
import { toast } from "sonner";

export default function FarmerMeetingsPage() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ date: "", location: "", no_of_farmers: "", topics: "", outcomes: "" });

  const load = async () => setRows((await api.get("/farmer-meetings")).data);
  useEffect(() => {
    load();
    // Initial fetch only on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/farmer-meetings", { ...form, no_of_farmers: Number(form.no_of_farmers) || 0 });
      toast.success("Meeting saved");
      setOpen(false);
      setForm({ date: "", location: "", no_of_farmers: "", topics: "", outcomes: "" });
      load();
    } catch (e) {
      toast.error(formatApiErrorDetail(e?.response?.data?.detail));
    }
  };

  return (
    <div>
      <PageHeader
        title="Farmer Meetings"
        subtitle="Development meetings, demos, field visits"
        actions={
          <Button onClick={() => setOpen((s) => !s)} data-testid="new-fm-btn">
            <Plus className="w-4 h-4" /> Log meeting
          </Button>
        }
      />
      {open && (
        <Card className="mb-6">
          <form onSubmit={submit} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <Label>Date</Label>
              <Input type="date" required value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} />
            </div>
            <div>
              <Label>Location</Label>
              <Input required value={form.location} onChange={(e) => setForm({ ...form, location: e.target.value })} />
            </div>
            <div>
              <Label># of farmers</Label>
              <Input type="number" value={form.no_of_farmers} onChange={(e) => setForm({ ...form, no_of_farmers: e.target.value })} />
            </div>
            <div className="sm:col-span-2">
              <Label>Topics covered</Label>
              <Textarea rows={2} value={form.topics} onChange={(e) => setForm({ ...form, topics: e.target.value })} />
            </div>
            <div className="sm:col-span-2">
              <Label>Outcomes</Label>
              <Textarea rows={2} value={form.outcomes} onChange={(e) => setForm({ ...form, outcomes: e.target.value })} />
            </div>
            <div className="sm:col-span-2 flex justify-end gap-2">
              <Button variant="outline" type="button" onClick={() => setOpen(false)}>
                Cancel
              </Button>
              <Button type="submit" data-testid="fm-submit">
                Save
              </Button>
            </div>
          </form>
        </Card>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {rows.length === 0 && <EmptyState title="No meetings logged yet" />}
        {rows.map((r) => (
          <Card key={r.id}>
            <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-[#5C6B5E]">
              <Users className="w-3.5 h-3.5" /> {r.no_of_farmers} farmers
            </div>
            <div className="font-heading text-lg font-bold mt-1">{r.location}</div>
            <div className="text-sm text-[#5C6B5E]">{r.date} · {r.user_name}</div>
            {r.topics && <div className="mt-3 text-sm"><span className="font-semibold">Topics:</span> {r.topics}</div>}
            {r.outcomes && <div className="mt-2 text-sm"><span className="font-semibold">Outcomes:</span> {r.outcomes}</div>}
          </Card>
        ))}
      </div>
    </div>
  );
}
